<template>
  <header class="app-layout__header">
    <DashboardBanner />
    <NavbarMain v-if="!$features.newSidebar" />
    <NavbarSecondary v-if="showSecondary && !$features.newSidebar" />
  </header>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    showSecondary?: boolean
  }>(),
  {
    showSecondary: true,
  }
)
</script>

<style></style>
